import * as React from "react";

import { StatelessPolicyConfirmed } from "./StatelessPolicyConfirmed";
import { useRiskProfilePolicy } from "../hooks/useRiskProfilePolicy";
import { SidePadder } from "kanopi-components/SpaceWrapper/SidePadder";
import { FlowLayout } from "kw/components/FlowLayout";

type TPolicyConfirmed = {
  riskProfileId: string;
};
const PolicyConfirmed: React.FC<TPolicyConfirmed> = ({ riskProfileId, ...props }) => {
  const [riskProfile, { loading }] = useRiskProfilePolicy(riskProfileId);
  return (
    <SidePadder padding="flow">
      <FlowLayout
        steps={[
          { label: "Your details", complete: true },
          { label: "Your quote", complete: true },
          { label: "Review and buy", complete: true },
        ]}
      >
        <StatelessPolicyConfirmed
          {...props}
          riskProfiles={
            riskProfile?.policyPeriods.length > 0
              ? [riskProfile]
              : riskProfile?.asParentInBundledRiskProfiles[0]?.riskProfiles
          }
          loading={loading}
        />
      </FlowLayout>
    </SidePadder>
  );
};

export { PolicyConfirmed };
